module.exports = __webpack_public_path__ + "static/lan-a45dec361f85a22b15e11bd917b0e690.jpg";